import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import { Badge } from 'react-bootstrap';

const TraplogLegend = ({ propertyStatuses, ...otherProps }) => {
  const [success, setSuccess] = useState();
  const [warning, setWarning] = useState();
  const [danger, setDanger] = useState();
  const [secondary, setSecondary] = useState();

  useEffect(() => {
    if (propertyStatuses) {
      var successCount = 0;
      var warningCount = 0;
      var dangerCount = 0;
      var secondaryCount = 0;

      propertyStatuses.forEach((propertyStatus) => {
        switch (propertyStatus.bgColor) {
          case 'success':
            successCount += 1;
            break;
          case 'warning':
            warningCount += 1;
            break;
          case 'danger':
            dangerCount += 1;
            break;
          case 'secondary':
            secondaryCount += 1;
            break;
        }
      });

      setSuccess(successCount);
      setWarning(warningCount);
      setDanger(dangerCount);
      setSecondary(secondaryCount);
    }
  }, [propertyStatuses]);

  return (
    <div {...otherProps}>
      <Badge pill variant='success' className='mx-1'>
        No Action Required / Sprayed {success ? <>({success})</> : ''}
      </Badge>
      <Badge pill variant='warning' className='mx-1'>
        Near Threshold {warning ? <>({warning})</> : ''}
      </Badge>
      <Badge pill variant='danger' className='mx-1'>
        Threshold Met {danger ? <>({danger})</> : ''}
      </Badge>
      <Badge pill variant='secondary' className='mx-1'>
        No Data {secondary ? <>({secondary})</> : ''}
      </Badge>
    </div>
  );
};

export default TraplogLegend;
